import { render, staticRenderFns } from "./ScrollArea.vue?vue&type=template&id=e5ffa8e2&"
import script from "./ScrollArea.vue?vue&type=script&lang=js&"
export * from "./ScrollArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports